import { lazy, Suspense } from 'react';

import APPLayout from 'Src/views/appLayout';
import HuMuYun3 from 'Src/views/HuMuYun3.0';
import BoarView from 'Src/views/boarView';

// 首页
const Home = lazy(() => import('Src/views/main-view/homePage'));
// 新闻
const News = lazy(() => import('Src/views/main-view/news'));
// 体验店
const ExperienceStore = lazy(() => import('Src/views/main-view/ExperienceStore'));
// 著实料
const PigStuff = lazy(() => import('Src/views/main-view/PigStuff'));
// 招聘
const Recruit = lazy(() => import('Src/views/main-view/recruit'));
// 联系
const Contact = lazy(() => import('Src/views/main-view/contact'));
// 碳中和
// const CarbonNeu = lazy(() => import('Src/views/main-view/CarbonNeu'));
// 母猪
const Sow = lazy(() => import('Src/views/HuMuYun3.0/Sow'));
// 公猪
const Boar = lazy(() => import('Src/views/HuMuYun3.0/boar'));
// 公猪APP
const BoarApp = lazy(() => import('Src/views/boarView/boarApp'));
// 互牧猪精
const BoarSperm = lazy(() => import('Src/views/boarView/boarSperm'));
// 智慧互牧
const AIoT = lazy(() => import('Src/views/HuMuYun3.0/AIoT'));
// 大数据平台
const BigData = lazy(() => import('Src/views/HuMuYun3.0/bigData'));
// 下载中心
const DownloadCenter = lazy(() => import('Src/views/HuMuYun3.0/download_center'));

const lazyLoad = (children) => {
  return <Suspense fallback={<>正在努力加载中。。。</>}>{children}</Suspense>;
};
const router = [
  {
    path: '/',
    element: <APPLayout />,
    children: [
      {
        index: true,
        element: lazyLoad(<Home />),
        title: '首页'
      },
      {
        path: '/product',
        element: lazyLoad(<> </>),
        title: '产品'
      },
      {
        path: '/news',
        element: lazyLoad(<News />),
        title: '新闻'
      },
      {
        path: '/store',
        element: lazyLoad(<ExperienceStore />),
        title: '体验店'
      },
      {
        path: '/report',
        element: lazyLoad(<PigStuff />),
        title: '猪事料'
      },
      {
        path: '/job',
        element: lazyLoad(<Recruit />),
        title: '招聘'
      },
      {
        path: '/contact',
        element: lazyLoad(<Contact />),
        title: '联系'
      },
      {
        path: '/HMCommunity',
        element: lazyLoad(<> </>),
        title: '互牧社区'
      }
      // {
      //   path: '/CarbonNeu',
      //   element: lazyLoad(<CarbonNeu />),
      //   title: '碳中和'
      // }
    ]
  },
  {
    path: '/humuyun',
    element: <HuMuYun3 />,
    isTwoRouter: true,
    children: [
      {
        index: true,
        copyPath: '/humuyun',
        element: lazyLoad(<Sow />),
        title: '母猪',
        pathName: '互牧云-V3.0',
        browserTitle: '互牧云猪场管理软件',
        describe:
          '该平台由互牧团队专门为母猪场打造,功能贸穿了母猪场所有业务流程,从配种、产房、保育/育肥等生产环节全流程管控。平台支持母猪繁殖数据录入、变动数据录入、健康管理录入,可单独使用，但我们强烈建议通过借助互牧云物联网相关设备的使用，实现员工工作中就能采集数据，提高了猪场数据采集的及时性,准确性,真实性。为猪场育种、管理决策等提供真实可靠的基础数据。此外，平台还涵盖育种，进销存及丰富的分析报表等，众多实用功能等着你来解锁。'
      },
      {
        path: '/humuyun/Boar',
        element: lazyLoad(<Boar />),
        title: '公猪',
        pathName: '互牧云-公猪站PC',
        browserTitle: '互牧云公猪站管理平台',
        describe:
          '该平台由互牧团队专门为公猪站打造,通过物联网的使用,软硬件完美配合,系统功能贯穿了公猪站所有业务流程,从公猪管理、采精管理、猪精检测、猪精制作管理、生产灌装、包装物流、销售管理、结算及售后,全流程管控,实现了公猪营养管理统一、猪精生产流程统一、销售管理统一。'
      },
      {
        path: '/humuyun/AIoT',
        element: lazyLoad(<AIoT />),
        title: '智慧互牧',
        pathName: '智慧互牧',
        browserTitle: '智慧互牧平台',
        describe:
          '通过智慧互牧相关硬件设备的使用，实现软件硬件完美结合,解决畜牧行业数据采集难、数据采集准确性差、真实性无法保障等痛点!我们致力于:应用互联网及物联网技术，促进畜牧业进入智能化管理时代。'
      },
      {
        path: '/humuyun/data',
        element: lazyLoad(<BigData />),
        title: '大数据',
        pathName: '互牧云-大数据',
        browserTitle: '互牧云猪场大数据可视化平台',
        describe:
          '猪场大数据整理，分析，并通过大数据可视化大屏展现，让你全面直观地了解、学控猪场状况.'
      },
      {
        path: '/humuyun/downLoad',
        element: lazyLoad(<DownloadCenter />),
        title: '下载',
        pathName: '互牧云-下载中心',
        browserTitle: '互牧下载中心',
        describe: '互牧下载中心'
      },
      {
        copyPath: '/',
        title: '关于互牧',
        pathName: '关于互牧'
      }
    ]
  },
  {
    path: '/BoarApp',
    element: <BoarView />,
    isThreeRouter: true,
    children: [
      {
        copyPath: '/humuyun/Boar',
        element: lazyLoad(<Boar />),
        title: '公猪站PC端',
        pathName: '互牧云-公猪站PC',
        browserTitle: '互牧云公猪站管理平台',
        describe:
          '该平台由互牧团队专门为公猪站打造,通过物联网的使用,软硬件完美配合,系统功能贯穿了公猪站所有业务流程,从公猪管理、采精管理、猪精检测、猪精制作管理、生产灌装、包装物流、销售管理、结算及售后,全流程管控,实现了公猪营养管理统一、猪精生产流程统一、销售管理统一。'
      },
      {
        index: true,
        copyPath: '/BoarApp',
        element: lazyLoad(<BoarApp />),
        title: '公猪站APP',
        pathName: '互牧云-公猪站APP',
        browserTitle: '互牧云公猪站管理系统v2.0-APP',
        describe:
          '互牧云公猪站管理APP是一款面向公猪站工作人员使用的APP，该APP集公猪个体管理、生产管理、进销存管理、检测仪、报表分析等功能为一体，实现了公猪站人员无纸化移动化办公，是公猪站管理的好帮手。'
      },
      {
        path: '/BoarApp/BoarSperm',
        element: lazyLoad(<BoarSperm />),
        title: '互牧猪精',
        pathName: '互牧云-互牧猪精APP',
        browserTitle: '互牧云猪精销售管理APP',
        describe:
          '互牧云公猪站管理APP是一款面向公猪站工作人员使用的APP，该APP集公猪个体管理、生产管理、进销存管理、检测仪、报表分析等功能为一体，实现了公猪站人员无纸化移动化办公，是公猪站管理的好帮手。'
      },
    ]
  }
];

export default router;
